import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {Session} from "../../../services/Session";
import {LoadingService} from "../../../services/LoadingService";
import {ToastService} from "../../../services/Toast.service";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {TaxStrategyOpportunitiesComponent} from "../tax-strategy-opportunities/tax-strategy-opportunities.component";
import {TaxStrategyPotentialRisksComponent} from "../tax-strategy-potential-risks/tax-strategy-potential-risks.component";
import {TpiqFroalaViewComponent} from "../../../tpiq-froala-view/tpiq-froala-view.component";
import {FoundationInit} from "../../../directives/foundation.directive";

declare let jQuery: any;

@Component({
  selector: 'app-tax-strategy-internal',
  standalone: true,
  imports: [CommonModule, FormsModule, TaxStrategyOpportunitiesComponent, TaxStrategyPotentialRisksComponent, TpiqFroalaViewComponent,
  FoundationInit],
  templateUrl: './tax-strategy-internal.component.html',
  styleUrl: './tax-strategy-internal.component.scss'
})
export class TaxStrategyInternalComponent implements OnInit, OnDestroy {
  @Input() taxStrategy: string;
  org: string =  Session.getOrg();
  user: string = Session.getUser().id;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  currentView = 'notes';

  constructor(
    private toastService: ToastService,
    private loadingService: LoadingService,
    private taxStrategyServices: ManageTaxStrategiesServices
  ) {}

  ngOnInit() {
    this._init();
  }

  _init() {
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.switchPage(this.currentView);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getFileData(file, isForVisualImage?){
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.downloadDocument(this.user, this.org, file.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (isForVisualImage) {
          file.temporaryURL = response.temporaryURL;
          file.fileType = 'image';
        } else {
          window.open(response.temporaryURL);
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const errorMessage = (isForVisualImage) ? 'Failed to get image file document' : 'Failed to download document';
        this.toastService.pop(TOAST_TYPE.error, errorMessage);
      });
  }

  switchPage(view){
    const base = this;
    this.currentView = view;
    jQuery('#a-notes').attr('aria-selected', 'false');
    jQuery('#a-opportunities').attr('aria-selected', 'false');
    jQuery('#a-risks').attr('aria-selected', 'false');
    jQuery('#a-' + view).attr('aria-selected', 'true');
  }

}
